module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-bc5f15f4!./packages/dof-simple-flow/diablo.css
// module id = 533
// module chunks = 0 1